//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Header";
//Install
import Footer from "../../../Footer";
//Install
import M597I5 from "../../../../Media/Image/053.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Aydınlatma : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik Aydınlatma; Her Projede Gerekli Olan Malzeme Desteğini, Kesintisiz Sağlayarak Çalışmaların Güvenle İlerlemesine Katkı Sunmaktadır."
        //Element
        let URL = "https://temaselektrik.com/sunulan-hizmetler/aydinlatma"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Aydınlatma"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Aydın",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "latma "
                                        ),
                                        //Element
                                        "Hizmetleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Aydınlatma; Her Projede Gerekli Olan Malzeme Desteğini, Kesintisiz Sağlayarak Çalışmaların Güvenle İlerlemesine Katkı Sunmaktadır. Bu Alanda Sunulan Sürekli ve Güvenli Hizmet İşlerimizin Temelini Oluşturmaktadır.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Elektrik Malzemelerinden Otomasyon Ekipmanlarına, Aydınlatma Ürünlerinden Kablo ve Şalt Malzemelerine Kadar İhtiyaç Duyulan Tüm Ürünleri, Kalite Esasına Uygun Şekilde Müşterilerimize Ulaştırıyoruz."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Elektromarket Hizmetleri; Bireysel Kullanıcıların, Kurumsal Projelerin Gereksinimlerini Karşılamak İçin Tasarlanmıştır. Geniş Stok Avantajı, Hızlı Temin Süreçleri ve Güvenilir Markalarla İş Birliği Sayesinde Her Ölçekten Projeye Doğru Ürünü Ulaştırıyoruz."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "v", title: "Aydınlatma", src: M597I5, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;